export default __webpack_public_path__ + "static/media/DCDLogo.7ed4ffa5.png";